import { render, staticRenderFns } from "./SentCurriculumsQuery.vue?vue&type=template&id=46fe86e2&lang=pug"
import script from "./SentCurriculumsQuery.vue?vue&type=script&lang=js"
export * from "./SentCurriculumsQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports